/* global gapi */
const CalendarAPI={
    _desc: undefined,
    _allDates: undefined,
    _calendar: undefined,
    loadApi(updateFunctionVar) {
        this.updateFunction = updateFunctionVar;
        const script = document.createElement("script");
        script.src = "https://apis.google.com/js/client.js";
    
        script.onload = () => {
            gapi.load('client:auth2', this.initClient.bind(this));
        };
    
        document.body.appendChild(script);
    },
    
    initClient() {
        gapi.client.init({
          apiKey: 'AIzaSyBtgF0KZbIqF7cc064sjbuI9JpHQ6Scsh0',
          clientId: '130041859892-ivnb6ipeeglv49k6k49o6gb2indsc2dq.apps.googleusercontent.com',
          discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"],
          scope: "https://www.googleapis.com/auth/calendar"
        }).then(()=> {
          // Listen for sign-in state changes.
          gapi.auth2.getAuthInstance().isSignedIn.listen((isSignedIn)=>{this.updateSigninStatus(isSignedIn)});

          //
          // Handle the initial sign-in state.
          this.updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());

          
          //authorizeButton.onclick = handleAuthClick;
          //signoutButton.onclick = handleSignoutClick;
          console.log("after init finish");

          
        });
    },


    updateSigninStatus(isSignedIn) {
        console.log("update signin");
        if (isSignedIn) {
            this.updateFunction(true);
            //alert("signed in");
            //this.listUpcomingEvents();
        } else {
          //authorizeButton.style.display = 'block';
          //signoutButton.style.display = 'none';
            this.updateFunction(false);
            //alert("signed out");
          //
          //
        }
    },

    signIn(){
        //if(!this.status)
        gapi.auth2.getAuthInstance().signIn();
    },

    signOut(){
        //if(this.status)
        gapi.auth2.getAuthInstance().signOut();
    },

    getStatus(){
        return this.status;
    },
    
    listUpcomingEvents() {
        console.log("list upcoming");
        gapi.client.calendar.events.list({
          'calendarId': 'primary',
          'timeMin': (new Date()).toISOString(),
          'showDeleted': false,
          'singleEvents': true,
          'maxResults': 10,
          'orderBy': 'startTime'
        }).then(function(response) {
          console.log(response);
        });
    },

    getCalendarsList(cb){
      var request = gapi.client.calendar.calendarList.list();
      request.execute(function(resp){
          var calendars = resp.items;
          console.log(calendars);
          if(cb) cb(calendars);
      });
    },


    pushAllEvents(eventDesc, calendar, alldates, cb){
      this._allDates = alldates;
      this._desc = eventDesc;
      this._calendar= calendar;
      console.log(this._allDates, this._desc, this._calendar);
      this.pushEvent(this._desc, this._allDates[0], this._calendar, this._allDates, 0, cb);
    },

    pushNextEvent(count, cb){
      console.log("push"+count);
      if(count<this._allDates.length)
        this.pushEvent(this._desc, this._allDates[count], this._calendar, this._allDates, count, cb);
    },
    pushEvent(eventDesc, date, calendar, alldates, count, cb){
        var event = {
            'summary': eventDesc+" #"+date.count,
            //'location': '800 Howard St., San Francisco, CA 94103',
            //'description': 'A chance to hear more about Google\'s developer products.',
            'start': {
              'date': this.yyyymmdd(date.date),
              //'timeZone': "Asia/Jerusalem"
            },
            'end': {
              'date': this.yyyymmdd(date.date),
              //'timeZone': "Asia/Jerusalem"
            },
           /* 'recurrence': [
              'RRULE:FREQ=DAILY;COUNT=2'
            ],*/
            'reminders': {
            //    'useDefault': true
              'useDefault': false,
              'overrides': [
                {'method': 'email', 'minutes': 7* 24 * 60},
                {'method': 'popup', 'minutes': 7* 24 * 60}
             ]
            }
          };
          
          var events= gapi.client.calendar.events;
          console.log(events);
          var request = events.insert({
            //'calendarId': 'primary',
            'calendarId': calendar,
            'resource': event
          });
          
          /*try{
          request.execute((event)=> {
            console.log('Event created: ' + event.htmlLink);
            if(cb) {
              if(event.htmlLink)
                cb(true);
              else
                cb(false);
            }
          });}
          catch(e){
            console.log(e);
            if(cb) cb(false);
          }*/
          console.log(request);
          this.tryPush(request, 0, count, cb);
    },

    tryPush(request, countofTries , countOfEvents, cb){
      try{
        request.execute((event)=> {
          console.log('Event created: ' + event.htmlLink);
          if(event.htmlLink)
          {
            if(cb)cb(true);
            this.pushNextEvent(countOfEvents+1, cb);
          }
          else
          {
            if(countofTries===5)
            {
              if(cb)cb(false);
              this.pushNextEvent(countOfEvents+1, cb);
            }
            else
              this.tryPush(request, countofTries+1, countOfEvents, cb);
          }
        });}
        catch(e){
          console.log(e);
          if(countofTries===5)
          {
            if(cb)cb(false);
            this.pushNextEvent(countOfEvents+1, cb);
          }
          else
            this.tryPush(request, countofTries+1, countOfEvents, cb);
        }
    },

    yyyymmdd(date, nextday){
        console.log(date);
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = (nextday? 1: 0)+date.getDate();
      
        return [date.getFullYear(),
                "-",
                (mm>9 ? '' : '0') + mm,
                "-",
                (dd>9 ? '' : '0') + dd
               ].join('');
    }
}


export default CalendarAPI;


// WEBPACK FOOTER //
// ./src/Codes/CalendarAPI.js